import { render, staticRenderFns } from "./Lobby1.vue?vue&type=template&id=c519044a"
import script from "./Lobby1.vue?vue&type=script&lang=js"
export * from "./Lobby1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports